module.exports = __webpack_public_path__ + "canny-segment-integration-4747f104a23b8498381cf9658d762fd7.webp";